import { render, staticRenderFns } from "./lrButtons.vue?vue&type=template&id=60543994&"
import script from "./lrButtons.vue?vue&type=script&lang=js&"
export * from "./lrButtons.vue?vue&type=script&lang=js&"
import style0 from "./lrButtons.vue?vue&type=style&index=0&id=60543994&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports